import {Stamp} from '../models/stamps/stamp';

export function formatStampHTML(stamp: Stamp): string {
  if (!stamp) return '';
  return '<div class="stamp">\n' +
    `    <div>${stamp.line1}</div>\n` +
    `    <div>${stamp.line2}</div>\n` +
    `    <div>${stamp.line3}</div>\n` +
    '</div>\n';
}
